import * as i from 'types';

export const transformQuestionId = (id: i.QuestionIds) => {
  if (id === 'fleetCar' || id === 'fleetVan') return 'fleet';
  return id;
};
